var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("Header", _vm._b({}, "Header", _vm.$route.meta, false)),
          _c("h2", { staticClass: "subtitle" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("global.total")) +
                " : " +
                _vm._s(_vm.totalCount) +
                " " +
                _vm._s(_vm.$t("global.crates")) +
                " "
            ),
            _c("br"),
            _vm._v(" " + _vm._s(_vm.plantData.name) + " "),
          ]),
          _c("div", { staticClass: "columns is-multiline" }, [
            _c(
              "div",
              { staticClass: "column", attrs: { id: "collected-crates" } },
              [
                _c("div", { staticClass: "box" }, [
                  _c("nav", { staticClass: "level is-mobile" }, [
                    _c(
                      "div",
                      { staticClass: "level-item has-text-centered" },
                      [
                        _c("b-icon", {
                          attrs: {
                            type: "is-primary",
                            size: "is-medium",
                            icon: "cube",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "level-item has-text-centered" }, [
                      _c("div", [
                        _c("p", { staticClass: "heading" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("pages.stock.available")) + " "
                          ),
                        ]),
                        _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.storages.find((e) => e.type === "1AVL")
                                  .totalCount
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "column", attrs: { id: "crate-collections" } },
              [
                _c("div", { staticClass: "box" }, [
                  _c("nav", { staticClass: "level is-mobile" }, [
                    _c(
                      "div",
                      { staticClass: "level-item has-text-centered" },
                      [
                        _c("b-icon", {
                          attrs: { size: "is-medium", icon: "cube" },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "level-item has-text-centered" }, [
                      _c("div", [
                        _c("p", { staticClass: "heading" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("pages.stock.dirty")) + " "
                          ),
                        ]),
                        _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.storages.find((e) => e.type === "2DIR")
                                  .totalCount
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _c("div", { staticClass: "column", attrs: { id: "crate-stock" } }, [
              _c("div", { staticClass: "box" }, [
                _c("nav", { staticClass: "level is-mobile" }, [
                  _c(
                    "div",
                    { staticClass: "level-item has-text-centered" },
                    [
                      _c("b-icon", {
                        attrs: {
                          type: "is-warning",
                          size: "is-medium",
                          icon: "cube",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "level-item has-text-centered" }, [
                    _c("div", [
                      _c("p", { staticClass: "heading" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("pages.stock.to_repair")) + " "
                        ),
                      ]),
                      _c("p", { staticClass: "subtitle" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.storages.find((e) => e.type === "3REP")
                                .totalCount
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "level-item has-text-centered" }, [
                    _c("p", { staticClass: "control" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-warning",
                          on: { click: _vm.fetchToReplaceBarcodes },
                        },
                        [
                          _c("b-icon", { attrs: { icon: "print" } }),
                          _c(
                            "span",
                            [[_vm._v(_vm._s(_vm.$t("global.barcode")))]],
                            2
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "column", attrs: { id: "enduser-count" } },
              [
                _c("div", { staticClass: "box" }, [
                  _c("nav", { staticClass: "level is-mobile" }, [
                    _c(
                      "div",
                      { staticClass: "level-item has-text-centered" },
                      [
                        _c("b-icon", {
                          attrs: {
                            type: "is-danger",
                            size: "is-medium",
                            icon: "cube",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "level-item has-text-centered" }, [
                      _c("div", [
                        _c("p", { staticClass: "heading" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("pages.stock.scrap")) + " "
                          ),
                        ]),
                        _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.storages.find((e) => e.type === "5SCR")
                                  .totalCount
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("ag-grid-vue", {
                  staticClass: "ag-theme-alpine",
                  staticStyle: { width: "100%", height: "700px" },
                  attrs: {
                    "grid-options": _vm.gridOptions,
                    pagination: true,
                    "pagination-auto-page-size": true,
                    "animate-rows": true,
                    "cache-overflow-size": 0,
                    "multi-sort-key": "ctrl",
                    "get-child-count": _vm.getChildCount,
                    modules: _vm.modules,
                  },
                  on: { "grid-ready": _vm.gridReady },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.barcodesToReplace.isModalActive,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              return _vm.$set(_vm.barcodesToReplace, "isModalActive", $event)
            },
            close: function ($event) {
              _vm.barcodesToReplace.checked = []
              _vm.fetchAll()
            },
          },
        },
        [
          _c("div", { staticClass: "modal-card" }, [
            _c("header", { staticClass: "modal-card-head" }, [
              _c("p", { staticClass: "modal-card-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("pages.stock.to_replace")) + " "),
              ]),
            ]),
            _c(
              "section",
              { staticClass: "modal-card-body" },
              [
                _c(
                  "b-field",
                  { attrs: { grouped: "" } },
                  [
                    _c(
                      "b-field",
                      [
                        _c("b-input", {
                          attrs: {
                            placeholder: "Search...",
                            type: "search",
                            icon: "search",
                          },
                          model: {
                            value: _vm.barcodesToReplace.inputSearch,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.barcodesToReplace,
                                "inputSearch",
                                $$v
                              )
                            },
                            expression: "barcodesToReplace.inputSearch",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: _vm.$t("global.export"),
                              position: "is-bottom",
                              type: "is-dark",
                            },
                          },
                          [
                            _c("b-button", {
                              attrs: {
                                type: "is-info",
                                "icon-left": "file-csv",
                                disabled:
                                  _vm.barcodesToReplace.checked.length === 0,
                              },
                              on: { click: _vm.exportToReplaceBarcodes },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: _vm.$t("pages.stock.print"),
                              position: "is-bottom",
                              type: "is-dark",
                            },
                          },
                          [
                            _c("b-button", {
                              attrs: {
                                type: "is-link",
                                "icon-left": "print",
                                disabled:
                                  _vm.barcodesToReplace.checked.length === 0,
                                loading: _vm.barcodesToReplace.isCreatingPDF,
                              },
                              on: { click: _vm.getPdfToReplaceBarcodes },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: _vm.$t("pages.stock.storage_dirty"),
                              position: "is-bottom",
                              type: "is-dark",
                            },
                          },
                          [
                            _c("b-button", {
                              attrs: {
                                type: "is-brown",
                                "icon-left": "dolly",
                                loading: _vm.barcodesToReplace.isPosting,
                                disabled:
                                  _vm.barcodesToReplace.checked.length === 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setStorage("2DIR")
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: _vm.$t("pages.stock.storage_clean"),
                              position: "is-bottom",
                              type: "is-dark",
                            },
                          },
                          [
                            _c("b-button", {
                              attrs: {
                                type: "is-white",
                                "icon-left": "dolly",
                                loading: _vm.barcodesToReplace.isPosting,
                                disabled:
                                  _vm.barcodesToReplace.checked.length === 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setStorage("1AVL")
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: _vm.$t("pages.stock.storage_repair"),
                              position: "is-bottom",
                              type: "is-dark",
                            },
                          },
                          [
                            _c("b-button", {
                              attrs: {
                                type: "is-warning",
                                "icon-left": "dolly",
                                loading: _vm.barcodesToReplace.isPosting,
                                disabled:
                                  _vm.barcodesToReplace.checked.length === 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setStorage("3REP")
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: "Add barcode",
                              position: "is-bottom",
                              type: "is-dark",
                            },
                          },
                          [
                            _c("b-button", {
                              attrs: {
                                type: "is-primary",
                                "icon-left": "add",
                                loading: _vm.barcodesToReplace.isPosting,
                              },
                              on: {
                                click: () => (_vm.addBarcodesModal = true),
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { "icon-left": "check" },
                        on: { click: _vm.checkAll },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("pages.stock.check_all")) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "b-table",
                  {
                    attrs: {
                      "per-page": 15,
                      data: _vm.filteredReplaceBarcodes,
                      "checked-rows": _vm.barcodesToReplace.checked,
                      "header-checkable": false,
                      loading: _vm.barcodesToReplace.isLoading,
                      checkable: "",
                      narrowed: "",
                      striped: "",
                      paginated: "",
                    },
                    on: {
                      "update:checkedRows": function ($event) {
                        return _vm.$set(
                          _vm.barcodesToReplace,
                          "checked",
                          $event
                        )
                      },
                      "update:checked-rows": function ($event) {
                        return _vm.$set(
                          _vm.barcodesToReplace,
                          "checked",
                          $event
                        )
                      },
                      "check-all": _vm.checkAll,
                      check: (row) => (_vm.barcodesToReplace.checked = row),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function (props) {
                          return [
                            _c("span", [_vm._v(_vm._s(props.column.label))]),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("b-table-column", {
                      attrs: { field: "barcode", label: "Barcode" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.barcode) + " "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("b-table-column", {
                      attrs: { field: "material", label: "Material" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.material) + " "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("b-table-column", {
                      attrs: { field: "quantity", label: "Quantity" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.quantity) + " "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("b-table-column", {
                      attrs: { field: "scannedAt", label: "Scanned at" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    new Date(
                                      props.row.scannedAt
                                    ).toLocaleString()
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("template", { slot: "bottom-left" }, [
                      _c("b", [_vm._v(_vm._s(_vm.$t("global.total")))]),
                      _vm._v(
                        ": " + _vm._s(_vm.filteredReplaceBarcodes.length) + " "
                      ),
                    ]),
                    _c("template", { slot: "empty" }, [_c("nothing-here")], 1),
                  ],
                  2
                ),
              ],
              1
            ),
            _c("footer", { staticClass: "modal-card-foot" }),
          ]),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.addBarcodesModal,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.addBarcodesModal = $event
            },
            close: () => (_vm.addBarcodesModal = false),
          },
        },
        [
          _c("div", { staticClass: "modal-card" }, [
            _c("header", { staticClass: "modal-card-head" }, [
              _c("p", { staticClass: "modal-card-title" }, [
                _vm._v(" Add barcode to replace "),
              ]),
              _c("button", {
                staticClass: "delete",
                attrs: { type: "button" },
                on: { click: () => (_vm.addBarcodesModal = false) },
              }),
            ]),
            _c(
              "section",
              { staticClass: "modal-card-body" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Barcode", horizontal: "" } },
                  [
                    _c("b-input", {
                      attrs: { placeholder: "Enter barcode", type: "text" },
                      model: {
                        value: _vm.barcodesToReplace.newBarcode.barcode,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.barcodesToReplace.newBarcode,
                            "barcode",
                            $$v
                          )
                        },
                        expression: "barcodesToReplace.newBarcode.barcode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "Quantity", horizontal: "" } },
                  [
                    _c(
                      "b-select",
                      {
                        model: {
                          value: _vm.barcodesToReplace.newBarcode.typNc,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.barcodesToReplace.newBarcode,
                              "typNc",
                              $$v
                            )
                          },
                          expression: "barcodesToReplace.newBarcode.typNc",
                        },
                      },
                      [
                        _c("option", { attrs: { value: "1" } }, [
                          _vm._v(" 1 "),
                        ]),
                        _c("option", { attrs: { value: "1.2" } }, [
                          _vm._v(" 2 "),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "footer",
              { staticClass: "modal-card-foot" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { type: "is-primary" },
                    on: { click: _vm.addBarcode },
                  },
                  [_vm._v(" Add ")]
                ),
                _c(
                  "b-button",
                  {
                    attrs: { type: "is-light" },
                    on: { click: () => (_vm.addBarcodesModal = false) },
                  },
                  [_vm._v(" Close ")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }